import React, { useEffect } from 'react';

const SiteVersion = ({ }) => {
    useEffect(() => {
        document.title = 'YTrac :: Site Version';
    }, []); // Empty dependency array to set the title only on mount

    const backgroundImageUrl = '/images/children-laughing-together.png';

    return (
        <div style={{ height: '100%' }}>
            <div className='top_div' style={{ backgroundImage: `url(${backgroundImageUrl})` }}>
                <div className='right-area'>
                    <div className="yt-siteselect-container">
                        <div className="yt-siteselect-row yt-siteselect-header-row">
                            <img src={require('../ywicon.png')} alt="Logo" className="yt-siteselect-logo" />
                            <h1 className="yt-siteselect-title">Y-Trac</h1>
                        </div>
                        <div className="yt-siteselect-row yt-siteselect-welcome-row">
                            <p>Version</p>
                            <p>4.250819.1</p>
                        </div>
                        <div className="yt-siteselect-row yt-siteselect-message-row">

                        </div>
                        <div className="yt-siteselect-row yt-siteselect-inputs-row">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SiteVersion;
